export const textHover = {
    "&:hover": {
        color: "primary.main"
    }
};

export const avatarHover = {
    "&:hover": {
        cursor: "pointer",
        backgroundColor: "primary.main",
    }
};